import { Component, OnInit } from '@angular/core';
import { Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { UploadFile, UploaderOptions, UploadInput, UploadOutput, humanizeBytes } from 'ngx-uploader';
import { severitymessage, SchedulesComponentmessage, FunctionalityNames, LanguageConstants } from '../../shared-components/constant';
import { environment } from 'src/environments/environment';
import { CoverIndexService } from 'src/app/services/coverindex.service';
import { WebJobQueueModel } from 'src/app/models/webJobQueue.model';
import { WebJobQueueService } from 'src/app/services/webjobqueue.service';
//import { debug } from 'util';
import { InfraService } from 'src/app/services/infra.service';
import { AuditingService } from 'src/app/services/auditing.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-popupconfirmdataTab',
  templateUrl: './popupconfirmdataTab.component.html',
  styleUrls: ['./popupconfirmdataTab.component.css']
})
export class PopupconfirmdataTabComponent implements OnInit {
  options: UploaderOptions;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  loadspinner = false;
  isFileFormatCorrect = false;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  humanizeBytes: Function;
  databook: any;
  dragOver: boolean;
  private loggedInUserData: UserModel[];
  downloadErrorLogConfigUrl: string;
  engagementId = +this.route.snapshot.paramMap.get('id');
  configUrl: string;
  dataTabconfigUrl: string;
  timeOutHandler: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  webJobQueueId: number;
  private loggedInUserId: number;
  previousStep: string;
  langCode: string;
  currLangTranslation: any;
  constructor(private infraService: InfraService, private route: ActivatedRoute, private router: Router, private userService: UserService,
    private coverIndexService: CoverIndexService, private messageService: MessageService
    , private confirmationService: ConfirmationService, private webJobQueueService: WebJobQueueService,
    private auditService: AuditingService, private translateService: TranslateService) {

    this.loggedInUserId = + localStorage.getItem('loggedInUserId');
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'databook/AddUploadedDatabookToQueue/' + this.engagementId;
      this.dataTabconfigUrl = data.WebEndPoint2 + 'databook/AddUploadedDatabookTemplateToQueue/' + this.engagementId;
      this.downloadErrorLogConfigUrl = data.WebEndPoint1 + 'filedownload/databookerrorlog/' + this.engagementId + '/' +
        this.loggedInUserId;
    });

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {

        this.loggedInUserData = [];
        this.loggedInUserData.push(userData);
      }
    });

    this.options = {
      concurrency: 1, allowedContentTypes: [
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    };
    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }


  @Input() displaydataTab = false;
  @Output() selecteddisplayevent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() okEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateDataTabEvent: EventEmitter<boolean> = new EventEmitter<boolean>();



  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];

    this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    });
  }
  ClosePopup() {
    if (this.displaydataTab) {
      this.displaydataTab = false;
      this.closeEvent.emit(this.displaydataTab);
    }
  }
  OkPopupclick() {
    this.displaydataTab = false;
    this.okEvent.emit(this.displaydataTab);
  }

  onUploadOutputData(output: UploadOutput, fileInput: any, databookType: number): void {
    if (output.file) {
      if (output.file.type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || output.file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.isFileFormatCorrect = true;
      } else {
        this.isFileFormatCorrect = false;
      }
    }

    if (this.isFileFormatCorrect === true) {
      if (output.type === 'allAddedToQueue') { // when all files added in queue
        // uncomment this if you want to auto upload files when added
        const event: UploadInput = {
          type: 'uploadAll',
          url: databookType === 1 ? this.configUrl : this.dataTabconfigUrl,
          method: 'POST',
          data: { loggedInUserId: <any>this.loggedInUserData[0].Id }
          , headers: {
            'Authorization': 'Bearer ' + (environment.isBearerAuthorizationEnabled ? localStorage['dbamsaltoken']
              : environment.sampleToken)
          }
        };

        this.uploadInput.emit(event);

      } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') { // add file to array when added

        this.sourceFiles.push(output.file);

      } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
        // update current data in files array for uploading file
        //  this.loadspinner = true;
        const index = this.sourceFiles.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
        this.sourceFiles[index] = output.file;

      } else if (output.type === 'done' && typeof output.file !== 'undefined') {
        this.loadspinner = true;

        if (output.file && output.file.response && output.file.response.message === 'Invalid File Format') {
          this.loadspinner = false;
          fileInput.value = '';
          this.uploadInput.emit({ type: 'remove', id: output.file.id });
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage = this.currLangTranslation.UploadSourcefilemessage.errorMessage.FormateError;
          return;
        }

        this.webJobQueueId = this.sourceFiles[0].response.id;
        if (this.sourceFiles[0].responseStatus === 200) {
          this.displaydataTab = false;
          this.closeEvent.emit(this.displaydataTab);
          this.confirmationService.confirm({
            message: this.currLangTranslation.schedulesComponentmessage.UploadWarning.message,
            header: this.currLangTranslation.labels.confirmation,
            acceptLabel: this.currLangTranslation.actionButtons.yes,
            rejectLabel: this.currLangTranslation.actionButtons.no,
            accept: () => {
              this.checkDatabookUploadProcessed();
            },
            reject: () => {
              this.loadspinner = false;
              if (this.displaydataTab) {
                this.displaydataTab = false;
                this.closeEvent.emit(this.displaydataTab);
              }
            }
          });

        } else if (this.sourceFiles[0].responseStatus === 400) {
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage = this.sourceFiles[0].response.message;
          this.loadspinner = false;
        } else {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
          });
          this.loadspinner = false;
        }
        this.sourceFiles = [];
        fileInput.value = '';
      } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
        this.loadspinner = false;

        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;

        // Replace with Notification service
        // this.messageService.add({
        //   key: this.currLangTranslation.severitymessage.key, severity: this.currLangTranslation.severitymessage.error,
        //   summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        // });
      } else if (output.type === 'removed') {
        this.loadspinner = false;
        // remove file from array when removed
        this.sourceFiles = this.sourceFiles.filter((file: UploadFile) => file !== output.file);
      } else if (output.type === 'dragOver') {
        this.dragOver = true;
      } else if (output.type === 'dragOut') {
        this.dragOver = false;
      } else if (output.type === 'drop') {
        this.dragOver = false;
      }
      this.auditService.addAudit(this.engagementId, FunctionalityNames.UploadDatabook).subscribe();
    } else if (this.isFileFormatCorrect === false) {
      this.loadspinner = false;
      this.isFileFormatCorrect = null;
      fileInput.value = '';
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage = this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
    }
  }

  confirmdisplay = false;
  closeEventworkallocation($event) {

    this.confirmdisplay = $event;
  }



  private checkDatabookUploadProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe((resp: WebJobQueueModel) => {
      if (resp) {
        if (!resp.isQueued) {
          this.isTimeIntervalInProgress = false;
          clearInterval(this.timeOutHandler);
          if (resp.isError) {
            this.loadspinner = false;
            if (resp.responseText === '') {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
              });
            } else {
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.displayMessage = resp.responseText;
            }
          } else {

            this.loadspinner = false;
            this.displaydataTab = false;
            this.ClosePopup();
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success
              , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.UploadDatabook, sticky: true, closable: true
            });
            this.updateDataTabEvent.emit(this.displaydataTab);
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinner = true;
              this.checkDatabookUploadProcessed();
            }, environment.webjobTimer);
          }
        }
      } else {
        if (!this.isTimeIntervalInProgress) {
          this.timeOutHandler = setInterval(() => {
            this.isTimeIntervalInProgress = true;
            this.loadspinner = true;
            this.checkDatabookUploadProcessed();
          }, environment.webjobTimer);
        }
      }
    }, err => {
      this.loadspinner = false;
      this.isTimeIntervalInProgress = false;
      clearInterval(this.timeOutHandler);
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
      });
    });
  }
}
